export default {
      id: "icon-toolsthin-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons.svg#icon-toolsthin",
      toString: function () {
        return this.url;
      }
    }